
import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import {CreateDHLratesSuccess, CreateDHLratesSuccessreturn, dhlratesActionTypes} from '../actions/dhl-rates';

export interface RatingDHLsState {
  // tslint:disable-next-line:no-any
  array: any[];
  // tslint:disable-next-line:no-any
  arrayReturn: any[];

}

const initialState: RatingDHLsState = {
  array: [],
  arrayReturn: []
};

export function ratingDHLReducer(state: RatingDHLsState = initialState, action: Action): RatingDHLsState {
  switch (action.type) {
    case dhlratesActionTypes.ADD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case dhlratesActionTypes.ADD_FAIL:
      return handleLoadFailAction(state);
    case dhlratesActionTypes.REMOVE_CLEAR:
      return handleClearAllAction();
    case dhlratesActionTypes.ADD_SUCCESS_RETURN:
      return handleLoadSuccessActionReturn(state, action);
    case dhlratesActionTypes.ADD_FAIL_RETURN:
      return handleLoadFailActionReturn(state);
    case dhlratesActionTypes.REMOVE_CLEAR_RETURN:
      return handleClearAllActionReturn();


    default:
      return state;
  }
}

function handleLoadSuccessAction(state: RatingDHLsState, action: CreateDHLratesSuccess): RatingDHLsState {
  const newState = _.clone(state);
  const datePipe = new DatePipe('en-US');
  const newProductPrice = _.cloneDeep(action.payload);
  if (newProductPrice) {
    for (let i = 0; i < newProductPrice.length; i++) {
      const formattedDate = datePipe.transform(newProductPrice[i].deliveryCapabilities.estimatedDeliveryDateAndTime, 'dd-MM-yyyy');
      // tslint:disable-next-line:max-line-length
      newProductPrice[i].productName = newProductPrice[i].productName + ' (' + newProductPrice[i].totalPrice[0].price + ') €' + ' estimated : ' + formattedDate ;
    }

    newProductPrice.sort((a, b) => a.totalPrice[0].price - b.totalPrice[0].price);
  }
  newState.array = newProductPrice;
  return newState;
}


function handleClearAllAction(): RatingDHLsState {
  return initialState;
}

function handleLoadFailAction(state: RatingDHLsState): RatingDHLsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

function handleLoadSuccessActionReturn(state: RatingDHLsState, action: CreateDHLratesSuccessreturn): RatingDHLsState {
  const newState = _.clone(state);
  const datePipe = new DatePipe('en-US');

  const newProductPrice = _.cloneDeep(action.payload);
  if (newProductPrice) {
    for (let i = 0; i < newProductPrice.length; i++) {
      const formattedDate = datePipe.transform(newProductPrice[i].deliveryCapabilities.estimatedDeliveryDateAndTime, 'dd-MM-yyyy');
      // tslint:disable-next-line:max-line-length
      newProductPrice[i].productName = newProductPrice[i].productName + ' (' + newProductPrice[i].totalPrice[0].price + ') €' + ' estimated : ' + formattedDate ;
    }

    newProductPrice.sort((a, b) => a.totalPrice[0].price - b.totalPrice[0].price);
  }
  newState.arrayReturn = newProductPrice;
  return newState;
}

function handleClearAllActionReturn(): RatingDHLsState {
  return initialState;
}

function handleLoadFailActionReturn(state: RatingDHLsState): RatingDHLsState {
  const newState = _.clone(state);
  newState.arrayReturn = [];
  return newState;
}

export const ratingDHLSelectors = {
  array: (state: RatingDHLsState) => _.get(state, 'array', []),
  arrayReturn: (state: RatingDHLsState) => _.get(state, 'arrayReturn', [])
}
